import React, { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthBanner } from './AuthBanner';
import './Setup.css';

const REDIRECT_DELAY_MS = 3000;

export function SignupSuccessPage() {
  const navigate = useNavigate();
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      navigate('/login', { replace: true });
    }, REDIRECT_DELAY_MS);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [navigate]);

  return (
    <div className="setup-container">
      {/* unmapped design value: 28rem also hardcoded in OnboardingWizard.tsx/SignupPage.tsx's setup-content, no shared token exists for it */}
      <div className="setup-content" style={{ maxWidth: '28rem' }}>
        <AuthBanner />
        <h1 className="h1">Signup successful</h1>
        <p className="mt-4 text-sm text-gray-600">
          You will be automatically redirected to the login page in a few seconds.
          If not, <Link to="/login" className="text-blue-600 hover:underline">click here</Link>.
        </p>
      </div>
    </div>
  );
}
